import dayjs from "dayjs";

import type { PatientFinderAppointmentMode } from "./patientFinderAppointmentMode";

/** Janela máxima retroativa quando só a data fim é informada (busca FHIR). */
const MAX_LOOKBACK_DAYS = 730;
/** Janela máxima futura quando só a data início é informada no modo agendada. */
const MAX_LOOKFORWARD_DAYS = 730;

export interface AppointmentPeriodBounds {
  /** ISO YYYY-MM-DD inclusive; null = sem limite neste lado. */
  from: string | null;
  to: string | null;
}

/**
 * Converte período opcional (início e/ou fim) em intervalo para `GetAppointment`.
 * Retorna null se nenhuma data foi informada.
 */
export function resolveAppointmentFetchDateRange(
  period: AppointmentPeriodBounds,
  mode?: PatientFinderAppointmentMode,
): { startDate: string; endDate: string } | null {
  const from = period.from?.trim() || null;
  const to = period.to?.trim() || null;

  if (!from && !to) return null;

  const today = dayjs().format("YYYY-MM-DD");

  let startDate = from ?? dayjs(to!).subtract(MAX_LOOKBACK_DAYS, "day").format("YYYY-MM-DD");
  // Consultas agendadas: sem data fim, busca até o futuro (não limitar só a hoje).
  let endDate =
    to ??
    (mode === "scheduled"
      ? dayjs().add(MAX_LOOKFORWARD_DAYS, "day").format("YYYY-MM-DD")
      : today);

  if (startDate > endDate) {
    const swap = startDate;
    startDate = endDate;
    endDate = swap;
  }

  return { startDate, endDate };
}

/** Rótulo legível do período informado pelo usuário. */
export function formatAppointmentPeriodLabel(period: AppointmentPeriodBounds): string {
  const from = period.from?.trim();
  const to = period.to?.trim();
  if (from && to) {
    return `${dayjs(from).format("DD/MM/YYYY")} – ${dayjs(to).format("DD/MM/YYYY")}`;
  }
  if (from) return `a partir de ${dayjs(from).format("DD/MM/YYYY")}`;
  if (to) return `até ${dayjs(to).format("DD/MM/YYYY")}`;
  return "não definido";
}
